<template>
<div> <!-- IE11 no toma el atributo :class definido en el elemento root del template -->
    <div :class="{
            'phi-post-item': true,
            'phi-post-item-selected': selected,
            'phi-post-item-unread': isUnread,
            'phi-post-item-read': !isUnread
        }"
    >
        <div class="phi-post-item-header phi-media">

            <div class="phi-media-figure phi-avatar" @click="$emit('toggle')">
                <div v-if="showIcon" class="post-type-icon">
                    <img v-if="type.icon" :src="type.icon" :alt="type.singular" />
                    <mu-icon v-else value="insert_drive_file" class="post-default-icon" />
                </div>
                <div v-if="!showIcon" class="post-author-avatar">
                    <img :src="value.author.avatar" :alt="value.author.firstName" />
                </div>
                <div v-if="$listeners.toggle" class="post-checkbox">
                    <mu-icon v-show="selected" class="icon-checked" value="check_box" />
                    <mu-icon v-show="!selected" class="icon-unchecked" value="check_box_outline_blank" />
                </div>
            </div>

            <div class="phi-media-body" @click="$emit('click')">
                <div class="post-item-stacker">
                    <div class="post-item-actions">
                        <mu-icon v-if="$listeners.edit && !isBlockObligationsReport" value="edit" @click.prevent="$emit('edit')"></mu-icon>
                        <mu-icon v-if="$listeners.delete" value="delete" @click.prevent="$emit('delete')"></mu-icon>
                    </div>
                    <div class="post-item-title" v-text="value.title ? value.title : $t('No business!')"></div>
                </div>

                <div class="post-item-tag post-item-tag-draft" v-if="isDraft" v-text="$t('post.draft')"></div>

                <div class="post-item-date" v-if="formattedPublishDate && !isScheduled" v-text="formattedPublishDate"></div>
                <div class="post-item-author">{{ value.author.firstName }} {{ value.author.lastName }}</div>
                <div class="post-item-preview" v-if="value.preview" v-text="value.preview"></div>

                <div class="post-item-tag post-item-tag-scheduled" v-if="isExpired"><mu-icon value="schedule"></mu-icon> {{ $t('post.expirationDate') }}: {{ formattedExpirationDate }}</div>

                <div class="phi-post-item-counters">
                    <ul class="counter-targets" v-if="targetCounts.sent">
                        <template v-for="(count, type) in targetCounts">
                            <li :key="type" v-if="count != null">
                                <mu-icon class="count-icon" v-if="countIcons[type]" :value="countIcons[type]"></mu-icon>
                                <span class="count" v-text="count"></span>
                            </li>
                        </template>
                    </ul>

                    <ul class="counter-blocks" v-if="value.event">
                        <li class="post-event" v-if="value.event">
                            <mu-icon value="event"></mu-icon>
                            <span class="count">{{ $date(value.event.startDate, value.event.allDay == '1' ? "day" : "date") }}</span>
                        </li>

                        <template v-for="(count, type) in value.blockCounts">
                            <li v-if="typeof blockIcons[type] != 'undefined'" :key="type">
                                <mu-icon :value="blockIcons[type]"></mu-icon>
                                <!-- <span class="count">{{ count }}</span> -->
                            </li>
                        </template>
                    </ul>

                    <div class="post-item-tag post-item-tag-scheduled" v-if="isScheduled"><mu-icon value="schedule"></mu-icon> {{ $t('post.scheduled') }}: {{ formattedPublishDate }}</div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "phi-post-item",

    i18n: {
        "es": {
            "post.draft": "borrador",
            "post.scheduled": "programado",
            "No business!": "!Sin asunto!",
            "post.expirationDate": "Fecha de vencimiento",
        },

        "en": {
            "post.draft": "draft",
            "post.scheduled": "scheduled",
            "No business!": "No business!",
            "post.expirationDate": "Expiration date",
        },

        "de": {
            "post.draft": "Entwurf",
            "post.scheduled": "geplant",
            "No business!": "kein Betreff",
            "post.expirationDate": "Verfallsdatum",
        }
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        selected: {
            type: Boolean,
            default: false
        },

        showIcon: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            blockIcons: {
                files: "attachment",
                form: "assignment",
                html: "text_format",
                youtube: "movie"
            },

            countIcons: {
                sent: "group",
                read: "visibility",
                ack: "mail",
                app: "smartphone"
            }
        };
    },

    computed: {
        isUnread() {
            return this.value.stub && !this.value.stub.internalReadDate;
        },

        isDraft() {
            return !this.value.publishDate;
        },

        isScheduled() {
            return this.value.publishDate && new Date(parseInt(this.value.publishDate) * 1000) > new Date();
        },

        isExpired() {
            return this.value.expirationDate && new Date(parseInt(this.value.expirationDate) * 1000) > new Date();
        },

        targetCounts() {
            return {
                sent: this.value.sent ? parseInt(this.value.sent) : null,
                read: this.value.read ? parseInt(this.value.internalRead) : null,
                ack: this.value.ack ? parseInt(this.value.ack) : null,
                // app: this.value.app ? parseInt(this.value.app) : null
            }
        },

        formattedPublishDate() {
            if (!this.value.publishDate) {
                return null;
            }

            return this.$date(this.value.publishDate);
        },

        formattedExpirationDate() {
            if (!this.value.expirationDate) {
                return null;
            }

            return this.$date(this.value.expirationDate);
        },

        /*
        Obtener un OBJETO tipo (singular, plural, color, icons) asociado al post
        Como el modelo de datos usado en este componente aun no es consistente (!) buscamos el tipo
        en distintos lugares:
        */
        type() {
            if (typeof this.value.type == "object") {
                return this.value.type;
            }

            if (typeof this.value.thread == "object" && typeof this.value.thread.head == "object" && typeof this.value.thread.head.type == "object") {
                return this.value.thread.head.type;
            }

            return {
                "id": this.value.type,
                "singular": this.value.type,
                "plural": this.value.type,
                "gender": 1,
                "color": null,
                "icon": null
            };
        },
        isBlockObligationsReport() {
            return this.value.blocks && this.value.blocks.some(b => b.type === 'obligationsReportPdf' || b.type === 'obligationsReport');
        }

    }
}
</script>

<style lang="scss">
.phi-post-item {
    cursor: pointer;

    .post-item-stacker {
        .post-item-actions {
            float: right;

            @media screen and (max-width: 400px) {
                float: none;
            }
        }
    }

    .post-item-title {
        font-weight: 400;
        font-size: 1.1em;
        margin: 0;
        padding: 0;
        word-wrap: break-word;
    }


    .post-item-actions {
        .mu-icon {
            color: #999;
            font-size: 22px;
            padding: 6px;
            border-radius: 3px;

            &:hover {
                background-color: rgba(0, 0, 0, .08);
            }

            &:last-child {
                margin-left: .5em;
            }
        }
    }



    .post-item-tag,
    .post-item-author,
    .post-item-date,
    .post-item-preview {
        font-size: .8em;
        color: #666;
        display: inline-block;
    }

    .post-item-preview {
        color: #888;
        font-size: .9em;
    }

    .post-item-tag {
        font-size: 11px;
        color: #fff;
        background-color: #666;

        // opacity: .5;
        padding: 4px 8px;
        border-radius: 6px;

        margin-right: .4em;
        width: fit-content;


        &.post-item-tag-scheduled {
            display: flex;
            align-items: center;
            color: #1A365D !important;
            background-color: #BEE3F8;
            .mu-icon {
                margin-right: 5px;
                font-size: 11px;
            }
        }
    }

    .post-item-author {
        margin-right: .4em;
    }

    .post-item-date {
        &::after {
            content: ' - ';
        }
    }

    .post-author-avatar,
    .post-type-icon {
        img {
            width: 100%;
        }
    }

    .post-type-icon {
        text-align: center;
        padding: 4px;
    }




    .phi-post-item-counters {
        display: flex;
        flex-wrap: wrap-reverse;
        padding-top: 3px;

        & > :first-child {
            margin-right: 1em;
        }

        & > :last-child {
            // flex: 1;
        }
    }

    .counter-targets,
    .counter-blocks {
        list-style: none;
        padding: 0;
        margin: 0;

        display: flex;

        li {
            display: flex;

            margin: 0 18px 0 0;
            padding: 4px 0;

            .count {
                color: #aaa;
                font-size: 11px;
                white-space: nowrap;
            }

            .mu-icon {
                color: #aaa;
                font-size: 16px;
                margin-right: 6px;
            }
        }
    }

    .counter-targets {
        li {
            .count,
            .mu-icon {
                color: #777;
            }
        }
    }


    .post-default-icon {
        font-size: 30px;
    }


    /* AVATAR CHECKBOX */
    .phi-post-item-header {

        .phi-media-figure {
            position: relative;

            .post-checkbox {
                position: absolute;
                top: 8px;
                text-align: center;

                color: #fff;

                .icon-unchecked {
                    text-shadow: 0 2px 6px rgba(0, 0, 0, .8);
                }

            }

            /* By default only the avatar is shown */
            .post-checkbox {
                opacity: 0;
            }

            /* The checkbox is show on hover */
            &:hover {
                .post-type-icon,
                .post-author-avatar {
                    opacity: .3;
                }

                .post-checkbox {
                    opacity: 1;
                }
            }

            /* checkbox and avatar opacity transition */
            .post-checkbox,
            .post-type-icon,
            .post-author-avatar {
                transition: opacity 120ms;
            }
        }
    }

    &.phi-post-item-selected {
        background-color: #edf4fd;
        .phi-post-item-header {
            .post-type-icon,
            .post-author-avatar {
                opacity: 0 !important;
            }
            .post-checkbox {
                opacity: 1;

                .mu-icon {
                    color: #666;
                }
            }
        }
    }

    &.phi-post-item-unread {
        .post-item-title,
        .post-item-date {
            font-weight: bold;
        }
    }
}
</style>